import React from 'react';
import PropTypes from 'prop-types';
// import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Link from 'next/link';
import AppCustomLink from '../Common/AppCustomLink';
import VisibilitySensor from 'react-visibility-sensor';
import { spacing, fixedSpacing, maxScreenSize, minImageWidth } from '../../lib/theme';
import {
  getPodcastImgSize, convertToSlug, isLocalStoragePresent, cleanText, cleanGenres,
  podcastSlugUrl, podcastHrefUrl, setCurrentPodcastData,
  bookImage,
  isAdmin
} from '../../lib/utils';

// import { Tooltip } from 'antd';
import SubscribeOption from './SubscribeOption';
import { Row, Col } from 'antd';
import SubscriberCount from './SubscriberCount';
import { logAdClick, logAdImpression } from '../../actions';
import { getIsPremiumUser } from '../../lib/fileUtils';

class PodcastTile extends React.Component {
  // loadPage = () => {
  //   message.loading('Loading...', 0);
  //   // Dismiss manually and asynchronously
  //   // setTimeout(hide, 2500);
  // }

  // componentWillUnmount() {
  //   message.destroy();
  // }

  saveSearchBool = (podcast) => {
    setCurrentPodcastData(podcast);
    const { fromSearch } = this.props;
    const fromSearchBool = fromSearch ? true : false;
    const podcastFeedUrl = podcast.feedUrl && podcast.feedUrl.split('?limit')[0];
    if (fromSearchBool) {
      console.dir('in searchBool');
      const searchBool = { feedUrl: podcastFeedUrl, time: new Date().getTime() };
      isLocalStoragePresent() && localStorage.setItem('lastSearchBool', JSON.stringify(searchBool));
    }
  }

  onVisibleChange = (isVisible) => {
    console.log('Element is now %s', isVisible ? 'visible' : 'hidden');
    const { adGenreId, podcast, parentAd } = this.props;
    if (isVisible) {
      logAdImpression(adGenreId, podcast.collectionId, parentAd);
    }
  }

  onClickPod = () => {
    const { adGenreId, podcast, parentAd } = this.props;
    logAdClick(adGenreId, podcast.collectionId, parentAd);
  }

  // const podcast = (props) => {
  render() {
    const { podcast, showSubscribe, size, showArtistName, showSeparator, userDetails } = this.props;
    const { borderColor, mainLayoutColor } = this.props.settingsState;
    const podcastId = podcast.id || podcast.collectionId;

    const itunesRawId = podcast.collectionId || '';
    // console.dir(podcast.feedUrl);
    // console.dir(podcastFeedUrl);
    let cleanedGenres = cleanGenres(podcast.genres);
    if (podcast.showAd) {
      cleanedGenres = ['Promoted', ...cleanedGenres];
    }
    let genres = cleanedGenres.join(', ');
    const mainDiv = <div className='post-item'>

      {/* <div className='post-item' onClick={this.props.onClick}> */}
      <Row style={{ width: '100%' }}>
        <Col span={4}>
          <div style={{ position: 'relative' }}>
            <AppCustomLink href={podcastHrefUrl(itunesRawId)} as={podcastSlugUrl(podcast.collectionName, itunesRawId)}>
              <a onClick={this.onClickPod} onMouseDown={this.saveSearchBool.bind(this, podcast)}>
                <img src={bookImage(podcast)} alt={`${podcast.collectionName || ''} podcast`} />

              </a>
            </AppCustomLink>
            {/* {
              showSubscribe && <div style={{ position: 'absolute', bottom: '12px', right: '0' }}>
                <SubscribeOption itunesId={podcastId} podcast={podcast} showSubscribers={false} />
              </div>
            } */}
          </div>
        </Col>

        <Col span={20} style={{ paddingLeft: `${spacing('lg')}`, paddingTop: '2em' }}>
          {isAdmin(userDetails) ? <p>{podcast.collectionId}</p> : <></>}
          <AppCustomLink href={podcastHrefUrl(itunesRawId)} as={podcastSlugUrl(podcast.collectionName, itunesRawId)}>
            <a onClick={this.onClickPod} onMouseDown={this.saveSearchBool.bind(this, podcast)}>
              <h2 className='title'>{podcast.collectionName}</h2>
              <div style={{ display: 'flex' }}>
                {/* <h4 className='title' style={{ width: '48px' }}>
                  <SubscriberCount subscribersFromParent={podcast?.subscribers || 0} /></h4>
                &#183; */}
                <h4 style={{ color: 'gray', textAlign: 'left', marginLeft: '0', marginRight: '0.5em', fontSize: '16px' }}
                  className='name'>{podcast.artistName}</h4>
                {/* &#183; */}
                {/* <h4 style={{ color: 'gray', textAlign: 'left', marginLeft: '0.5em' }}>{genres}</h4> */}
              </div>
              <p>{podcast.description || ''}</p>
            </a>
          </AppCustomLink>
        </Col>

      </Row>


      {showSeparator && <hr className='separator' />}
      <style jsx>
        {`
            img {
              width: 100%;
              min-height: ${size === 'lg' ? '120px' : '120px'}; // so that images load better.
              // max-height: 160px; // so that images load better.
              min-width: ${minImageWidth};
              border-radius: ${spacing('sm')};
              // box-shadow: 0 8px 8px rgba(0,0,0,0.30), 0 4px 4px rgba(0,0,0,0.22);
              box-shadow: 0 20px 40px 0 rgba(0,11,40,.14);
              margin-bottom: 1em;
            }
           .post-item{
              // flex: 0 0 ${size === 'lg' ? '12em' : '7.5em'};
              // min-width: ${size !== 'lg' && '90px'}; // 80px;
              // width: ${size != 'lg' && '100px'};
              cursor: pointer;
              // display: inline-block;
              // width: ${size === 'md' ? '120px' : '160px'};
              // max-width: 420px;
              // margin-right: calc(${size === 'lg' ? 2.5 : 3.5} * ${fixedSpacing()});
              margin-bottom: calc(2 * ${fixedSpacing()});
              background: ${mainLayoutColor}; // white;
              // flex-basis: 15%;
           }
           @media ${maxScreenSize.laptop} {
             img{
                 width: 10vw;
                  min-height: 80px; // so that images load better.
                  min-width: 80px; // so that images load better.
                  border-radius: ${spacing('xs')};
             }
             .post-item{
                // margin-right: 0;
                // max-width: 120px;
             }
           }
           .details {
              max-width: 160px;
              text-align: center;
            //  padding-left: ${spacing('md')};
           }
           .title {
             text-align: left;
              // white-space: nowrap;
              // overflow: hidden;
              // text-overflow: ellipsis;
              // max-width: 180px;
              margin-bottom: 0;
           }
           .name {
              // max-width: 180px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2; /* number of lines to show */
              -webkit-box-orient: vertical;
           }
        `}
      </style>
    </div >
    if (podcast['isAd'] && !getIsPremiumUser()) {
      return (
        <VisibilitySensor onChange={this.onVisibleChange}>
          {mainDiv}
        </VisibilitySensor>
      )
    } else {
      return (
        mainDiv
      )
    }
  }
}
PodcastTile.defaultProps = {
  size: 'md',
  showArtistName: false,
  showSeparator: false
}

PodcastTile.propTypes = {
  userDetails: PropTypes.object,
  podcast: PropTypes.object,
  settingsState: PropTypes.object,
  showSubscribe: PropTypes.bool,
  showSeparator: PropTypes.bool,
  fromSearch: PropTypes.bool,
  showArtistName: PropTypes.bool,
  size: PropTypes.string,
  adGenreId: PropTypes.string,
  parentAd: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    settingsState: state.settingsState,
    userDetails: state.userDetails,
  }
}

export default connect(mapStateToProps, null)(PodcastTile)